export const pageSeo = {
  home: {
    title: 'Leavitt Peak Press | Book Publisher in Cerritos, CA',
    description:
      'Independent publisher in Cerritos, CA: BBB A+ rated, BusinessRate Top 10 2026, and an IPG member. Documented book-fair participation, no sales guarantees.',
    keywords:
      'Leavitt Peak Press, independent book publisher Cerritos, BBB A+ publisher, BusinessRate Top 10 2026, IPG member publisher',
    path: '/',
  },
  services: {
    title: 'Book Publishing Services | Leavitt Peak Press',
    description:
      'Editing, design, distribution, and marketing services from Leavitt Peak Press. Clear written scope, honest timelines, and no guaranteed sales figures.',
    keywords:
      'book publishing services, self publishing packages, book editing and design, book marketing for authors, book distribution services',
    path: '/services',
  },
  aboutUs: {
    title: 'About Leavitt Peak Press | Our Honest Position',
    description:
      "Read Leavitt Peak Press's honest position: what we control, what we never claim, and the documented participation behind every promise we make to authors.",
    keywords:
      'about Leavitt Peak Press, honest book publisher, publishing representation, book publisher transparency, no bestseller guarantee',
    path: '/about-us',
  },
  contactUs: {
    title: 'Contact Leavitt Peak Press | Publishing Consultation',
    description:
      'Talk to a Leavitt Peak Press consultant about your manuscript, and ask us straight what we will and will not promise for your book before you sign anything.',
    keywords:
      'contact book publisher, publishing consultation, submit manuscript, Leavitt Peak Press contact, book publishing quote',
    path: '/contact-us',
  },
  events: {
    title: 'Book Fairs & Publishing Events | Leavitt Peak Press',
    description:
      'Upcoming book fairs and past event reports from Leavitt Peak Press, including Frankfurt, London, Los Angeles, and Miami, with booth details and photographs.',
    keywords:
      'book fairs 2026, Frankfurt Book Fair, London Book Fair, LA Times Festival of Books, Miami Book Fair, Leavitt Peak Press events',
    path: '/events',
  },
  frankfurt2026: {
    title: 'Frankfurt Book Fair 2026 Report | Leavitt Peak Press',
    description:
      'Five days at stand A104 in Halle 3.1: the titles, the visitors, and the photographs from Leavitt Peak Press at Frankfurt Book Fair 2026.',
    keywords:
      'Frankfurt Book Fair 2026, Leavitt Peak Press booth A104, Halle 3.1, book fair event report, international book rights',
    path: '/events/frankfurt-book-fair-2026',
  },
  verifiedParticipation: {
    title: 'Verified Book Fair Participation | Leavitt Peak Press',
    description:
      'Every book fair Leavitt Peak Press can document, with venues, dates, booth numbers, and dated photographs from the floor. The evidence behind the claims.',
    keywords:
      'verified book fair participation, Leavitt Peak Press booth numbers, documented publishing events, book fair photographs, publishing transparency',
    path: '/events/verified-participation',
  },
  ratings: {
    title: 'Ratings & Awards | Leavitt Peak Press | BBB A+ & Top 10',
    description:
      'BBB A+ rating, 5.0 Google rating, IPG membership and the BusinessRate Top 10 2026 award for Top Publisher in Los Angeles County. Verify each of them yourself.',
    keywords:
      'Leavitt Peak Press ratings, BusinessRate Top 10 2026, Top Publisher Los Angeles County, BBB A+ publisher, Google 5 star book publisher, IPG member publishing',
    path: '/ratings',
  },
  terms: {
    title: 'Terms and Conditions | Leavitt Peak Press',
    description:
      'The terms and conditions covering Leavitt Peak Press publishing services, author responsibilities, and the written scope of work agreed before a project begins.',
    keywords: 'Leavitt Peak Press terms, publishing service agreement, book publishing terms and conditions',
    path: '/terms-and-conditions',
  },
  privacy: {
    title: 'Privacy Policy | Leavitt Peak Press',
    description:
      'How Leavitt Peak Press collects, uses, and protects the personal information you share through this website, newsletter signup, and publishing consultations.',
    keywords: 'Leavitt Peak Press privacy policy, author data protection, publishing company privacy',
    path: '/privacy-policy',
  },
};